export enum SelectRunsOption {
  All = 'ALL',
  None = 'NONE',
  Completed = 'COMPLETED',
  Running = 'RUNNING',
  Scheduled = 'SCHEDULED'
}
